import { computed } from "vue";
import { useAuthentication } from "../composables/use-authentication";
import { AuthenticationState } from "../models/authentication-state";

export namespace AuthenticationAnalytics {
    const getAnalyticsAuthLocation = () => {
        const { currentState } = useAuthentication();

        switch (currentState.value) {
            case AuthenticationState.Login:
            case AuthenticationState.LoginOtp:
            case AuthenticationState.ForcedPasswordReset:
            case AuthenticationState.ForcedPasswordResetOtp:
                return "login";
            case AuthenticationState.ForgottenPassword:
            case AuthenticationState.PasswordReset:
            default:
                return "forgottenPassword";
        }
    };

    const analyticsAuthLocation = computed(getAnalyticsAuthLocation);

    export const pushLoginPopup = () => {
        window.dataLayer.push({
            page: {
                type: "account.login",
                kind: "widget.login",
                verticalCodeStrict: "no_vertical",
                gameCodeStrict: "no_game",
                pageviewType: "popup",
            },
            event: "page",
        });
    };

    export const pushLogin2FAPopup = () => {
        window.dataLayer.push({
            page: {
                type: "account.login",
                kind: "2FAwidget.login",
                verticalCodeStrict: "no_vertical",
                gameCodeStrict: "no_game",
                pageviewType: "popup",
            },
            event: "page",
        });
    };

    export const pushLoginSuccess = () => {
        window.dataLayer.push({
            event: "action.login.user",
        });
    };

    export const pushLoginFailure = () => {
        window.dataLayer.push({
            event: "action.loginFailed.user",
        });
    };

    export const pushRegistrationClick = () => {
        window.dataLayer.push({
            event: "action.click.navigation",
            action: {
                click: {
                    name: "registration",
                    eventProperty1: `${analyticsAuthLocation.value}.popup`,
                    eventProperty2: `${analyticsAuthLocation.value}.popup`,
                },
            },
        });
    };

    export const pushChatClick = () => {
        window.dataLayer.push({
            event: "action.click.navigation",
            action: {
                click: {
                    name: "chat",
                    eventProperty1: `${analyticsAuthLocation.value}.popup`,
                    eventProperty2: `${analyticsAuthLocation.value}.popup`,
                },
            },
        });
    };

    export const pushHelpCenterClick = () => {
        window.dataLayer.push({
            event: "action.click.navigation",
            action: {
                click: {
                    name: "help center",
                    eventProperty1: `${analyticsAuthLocation.value}.popup`,
                    eventProperty2: `${analyticsAuthLocation.value}.popup`,
                },
            },
        });
    };

    export const pushForgottenPasswordSendCodeClick = () => {
        window.dataLayer.push({
            event: "action.click.button",
            action: {
                click: {
                    name: "forgottenPassword.sendCode",
                },
            },
        });
    };

    export const pushForgottenPasswordPopup = (headline: string) => {
        window.dataLayer.push({
            event: "action.impress.promos",
            action: {
                impress: {
                    promos: [
                        {
                            id: "forgottenPassword.login",
                            name: "forgottenPassword.login",
                            creative: headline,
                            position: "popup",
                        },
                    ],
                },
            },
        });
    };

    export const pushLogoutPopup = (headline: string) => {
        window.dataLayer.push({
            event: "action.impress.promos",
            action: {
                impress: {
                    promos: [
                        {
                            id: "logout",
                            name: "logout",
                            creative: headline,
                            position: "popup",
                        },
                    ],
                },
            },
        });
    };
}
